import authActions from './auth.js';
import emailConflictActions from './emailConflict.js';
import emailVerificationActions from './emailVerification.js';
import mfaActions from './mfa.js';
import otpActions from './otp.js';
import passwordResetActions from './passwordReset.js';
import ssoActions from './sso.js';

export default {
  ...authActions,
  ...emailConflictActions,
  ...emailVerificationActions,
  ...mfaActions,
  ...otpActions,
  ...passwordResetActions,
  ...ssoActions,
};
